import * as React from "react";
import { Moment } from "moment"
import { introEvents, timelineEvents } from "../../timeline_events";
import { TimelineEvent } from "./timeline_event";

interface TimeLineProps {
    startDate: Moment;
}

interface Event {
    title: string;
    img: string;
    offset?: number;
    disclaimer?: string;
    description?: string;
}

export function TimeLine({ startDate }: TimeLineProps): JSX.Element {
    const introEventElements = introEvents.map(({ title, img, description }: Event, idx: number) =>
        <TimelineEvent title={title} img={img} idx={idx} description={description} />
    );
    const timelineEventElements = timelineEvents.map(({ title, offset, img, disclaimer }: Event, idx: number) =>
        <TimelineEvent title={title} startDate={startDate} offset={offset} img={img} idx={idx + introEvents.length} disclaimer={disclaimer} />
    );
    return (
        <div className="timeline__parent">
            { [...introEventElements, ...timelineEventElements] }
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/ts/components/calculator/timeline.tsx